{
  "hero": {
    "title": "隱私權說明",
    "description": "說明 NAPAICP 競賽平台蒐集哪些個人資料、為何蒐集，以及誰可以存取這些資料。資料的保存期限、作品權利與刪除申請方式，請見資料保存政策頁面。"
  },
  "quickNav": {
    "label": "頁內導覽",
    "collect": "蒐集哪些資料",
    "purpose": "為何蒐集",
    "access": "誰可以存取",
    "thirdParty": "第三方服務",
    "children": "未成年使用者",
    "related": "相關頁面"
  },
  "collect": {
    "heading": "蒐集哪些資料",
    "description": "依您在平台上的角色與操作，平台可能蒐集以下資料：",
    "items": {
      "identity": "姓名、Email、就讀或任職學校／單位；評審另可自行填寫服務單位、職稱、專長與簡介（僅該場競賽的主辦方可見）",
      "team": "隊伍名稱、隊伍成員關係、指導教師資料",
      "submission": "競賽報名內容、作品繳交檔案與表單答案",
      "scoring": "評審針對作品所填寫的評分與評語（僅評審與有權限的主辦方可見），以及評審須知的確認時間與婉拒評審邀請時選填的原因（主辦方可見）",
      "activity": "帳號相關的系統操作紀錄，例如登入時間、密碼變更、Session 相關事件",
      "event": "使用活動服務（接駁車、餐飲、客服）時：乘車真實姓名、單位、職稱與選填的行動電話，同行者姓名，接駁預約與驗票紀錄，午餐與宴會回覆、飲食類別與備註，客服案件內容，以及選用的發車前提醒同意；Email 預約另會暫存待確認的請求。行動電話與飲食備註以加密儲存，上述資料於活動結束後 30 天自動刪除。"
    }
  },
  "purpose": {
    "heading": "為何蒐集",
    "items": {
      "auth": "帳號驗證與登入",
      "eligibility": "確認競賽報名資格",
      "submission": "管理與保存競賽作品",
      "judging": "支援評審流程與成績計算",
      "notification": "通知報名、評分與結果相關事項",
      "audit": "稽核與安全防護，例如偵測異常存取"
    }
  },
  "access": {
    "heading": "誰可以存取",
    "description": "存取權限依角色與資料範圍區分，不會因為某人擁有較高權限就自動取得所有人的所有資料：",
    "roles": {
      "participant": {
        "title": "參賽者",
        "description": "可存取自己與所屬隊伍的資料，看不到其他隊伍的作品或評分內容。"
      },
      "judge": {
        "title": "評審",
        "description": "只能存取被指派的作品與相關評分資料；評審端 API 不回傳不應揭露的參賽者身分資訊。"
      },
      "organizer": {
        "title": "競賽主辦方",
        "description": "可管理自己負責的競賽，包含該場競賽的報名、作品、評審與結果資料；不能存取其他競賽的資料。"
      },
      "platformAdmin": {
        "title": "平台管理員",
        "description": "可依治理需求跨競賽查詢必要資訊，平台列表僅回傳治理用途必要的最小欄位；需要更敏感資訊時，必須透過明確的操作與額外權限，並留下稽核紀錄。"
      },
      "eventStaff": {
        "title": "活動工作人員",
        "description": "依活動內角色最小授權：驗票人員只見姓名、單位、職稱與驗票結果；行動電話僅活動 owner 在緊急聯絡時可查看並留有紀錄；飲食明細只有 owner 與 manager 可匯出且每次匯出留有紀錄。"
      }
    }
  },
  "thirdParty": {
    "heading": "第三方服務",
    "description": "本平台部分功能依部署環境設定使用下列第三方服務；是否啟用視環境而定，實際情形以登入頁與功能行為為準：",
    "items": {
      "oidc": "若您的帳號透過學校／機構單一登入（OIDC，目前以 Google Workspace 為對接對象）登入，該身分提供者會處理您的登入驗證與基本個人資料（例如 Email、姓名）。",
      "turnstile": "註冊、登入與密碼重設請求會經過 Cloudflare Turnstile 進行機器人防護驗證，此過程會將您的 IP 位址與驗證權杖傳送至 Cloudflare。",
      "email": "系統通知信（例如驗證信、密碼重設信、評審邀請信）透過 Cloudflare Email Service 寄送，寄送對象僅限您提供的 Email 地址。另包含評審的新指派通知、指派調整通知、評分重新開放通知與評審進度提醒（含主辦方啟用時的截止前自動提醒）；這些信不會列出作品或隊伍身分，也不會包含主辦方重新開放分數時填寫的原因。"
    }
  },
  "children": {
    "heading": "未成年使用者",
    "description": "若使用者為未成年學生，建議由所屬學校、指導教師或監護人協助確認報名資訊之正確性；如需就未成年使用者的個資處理提出疑問，請透過下方聯絡管道與我們聯繫。"
  },
  "related": {
    "heading": "相關頁面",
    "dataPolicy": "資料保存政策（保存期限、作品權利、帳號與資料刪除）",
    "terms": "使用條款",
    "trust": "Trust Center",
    "contact": "如對本說明有疑問，請寄信至"
  }
}
